import { Rating } from '@mantine/core';
import cs from 'classnames';
import Image from 'next/image';
import type { FC } from 'react';
import type { ISubscriptionComment } from '@/Module/Subscription/Component/SubscriptionCommentSlider/SubscriptionCommentSlider';
import { FILE_BROWSER_URL } from '../../../Core/Constant';
import CanvasSubscription from './CanvasSubscription';
const SubscriptionComment: FC<ISubscriptionComment> = ({
  comment,
  name,
  rating,
  grade,
  img
}) => {
  return <div className="relative  mx-auto h-[250px]  w-[300px]" data-sentry-component="SubscriptionComment" data-sentry-source-file="SubscriptionComment.tsx">
      <CanvasSubscription data-sentry-element="CanvasSubscription" data-sentry-source-file="SubscriptionComment.tsx" />
      <Rating value={rating} fractions={2} size="lg" readOnly className="relative z-10  " style={{
      display: 'flex',
      flexDirection: 'row-reverse',
      width: '100%',
      paddingTop: '20px',
      paddingLeft: '20px'
    }} data-sentry-element="Rating" data-sentry-source-file="SubscriptionComment.tsx" />
      <div className="relative z-10 mt-5 line-clamp-4 h-[98px] whitespace-break-spaces px-8 text-justify text-sm leading-[1.8]">
        {comment}
      </div>
      <div className="relative z-10 mt-3 pr-24 ">
        <div className="mb-1  font-bold text-blackFive">{name}</div>
        <div className="text-sm text-blackFour">{grade}</div>
      </div>
      <Image width={55} height={55} src={`${FILE_BROWSER_URL}/img/${img}.png`} className={cs(`rounded-full absolute bottom-0 right-2 z-10`)} alt="person" data-sentry-element="Image" data-sentry-source-file="SubscriptionComment.tsx" />
    </div>;
};
export default SubscriptionComment;